module.exports = __webpack_public_path__ + "img/MDI-arrow-down-bold.5a537d2a.svg";